import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, FormGroup, ControlLabel, FormControl, InputGroup, Alert, Panel } from 'react-bootstrap';
import TemplateProducer from './template-producer';
import connect from './connect';

class PageTemplateProducer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      template: {
        title: '',
        description: '',
        instructions: '',
        reactComponentName: '',
        ...(this.props.template || {})
      }
    }

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(name, value) {
    this.setState({
      template: {
        ...this.state.template,
        [name]: value
      }
    });
  }
  save() {
    if(this.props.page_template_manager.creating || this.props.page_template_manager.updating) {
      return;
    }
    if(!this.state.template._id) {
      this.props.createPageTemplate(this.state.template);
    }
    else {
      this.props.updatePageTemplate(this.state.template);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { page_template_manager: ptm } = nextProps;
    const { page_template_manager: this_ptm } = this.props;

    if(ptm.error && !this_ptm.error || ptm.error && this_ptm.error.message != ptm.error.message) {
      this.props.notify(ptm.error);
    }
    if(this_ptm.creating && !ptm.creating && !ptm.error) {
      //TODO: Finish saving.
      this.props.push('/sales-site/page-templates');
    }
  }
  render() {
    const { page_template_manager: { creating, updating } } = this.props;
    return (
      <Row>
        <Col xs={12}>
          <h1>Page Template</h1>
          <p>Create a new page template.</p>
        </Col>
        <Col xs={12}>
          <Panel footer={
            <Row>
              <Col xs={12}>
                <Button onClick={e => this.save()} className='pull-right' bsStyle='primary'>{creating || updating ? <i className='fa fa-spin fa-spinner' /> : 'Save'}</Button>
              </Col>
            </Row>
          }>
            <TemplateProducer
              {...this.state.template}
              onChange={(name, value) => this.handleChange(name, value)}
            />
          </Panel>
        </Col>
      </Row>
    );
  }
}

export default connect(PageTemplateProducer);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/page-template-producer.js